// extracted by css-extract-rspack-plugin
module.exports =  {"icon":"Icon-m__icon___i_pZV","defaultSize":"Icon-m__defaultSize___MgEpP"};